<template>
  <div class="grid-view">
    <div class="main-content">
      <div class="app-main-inner-row">
        <div class="filters">
          <el-form :inline="true" label-width="40px" label-position="left" @submit.native.prevent>
            <div class="el-form-item-wrapper">
              <el-form-item :label="$t('CargoMsg.Cargo_Search')">
                <el-input v-model="searchConditions.likeName" @input="filterSearch" />
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div class="triggers">
          <el-button type="primary" @click="toAdd">{{ $t('common.btn.new') }}</el-button>
          <el-button type="primary" @click="toEdit">{{ $t('common.btn.edit') }}</el-button>
          <el-button type="danger" @click="doDelete">{{ $t('common.btn.delete') }}</el-button>
          <el-button type="primary" @click="fetchEDITemplateList">{{ $t('common.btn.refresh') }}</el-button>
        </div>
      </div>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          config-module="260305"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
        />
      </div>
    </div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="maintainDialog.isShow"
      :close-on-click-modal="false"
      :title="maintainDialog.title"
      width="850px"
    >
      <div style="display: flex;">
        <el-form :model="maintainDialog.maintainForm" label-width="210px" label-position="right">
          <div class="el-form-item-wrapper">
            <el-form-item :label="$t('SystemMaintenance.EDIFileDefaultTypeDefaultFileType')">
              <el-input v-model="maintainDialog.maintainForm.defaultFileType" :style="'width: 250px;'" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_EDIFileType')">
              <el-input v-model="maintainDialog.maintainForm.uploadFileSuffix" />
            </el-form-item>
            <el-form-item :label="$t('SystemMaintenance.Emailemail')">
              <el-input v-model="maintainDialog.maintainForm.email" />
            </el-form-item>
            <el-form-item :label="$t('SystemMaintenance.EDIFileEncodingTypeEncodingType')">
              <el-input v-model="maintainDialog.maintainForm.encodingType" />
            </el-form-item>
            <el-form-item :label="$t('SystemMaintenance.EDIFileCombinationMethodFileCombineType')">
              <el-input v-model="maintainDialog.maintainForm.fileCombineType" />
            </el-form-item>
            <el-form-item :label="$t('SystemMaintenance.PartnerCodeParnterId')">
              <el-input v-model="maintainDialog.maintainForm.parnterId" />
            </el-form-item>
            <el-form-item :label="$t('SystemMaintenance.Remarksremarks')">
              <el-input v-model="maintainDialog.maintainForm.remarks" />
            </el-form-item>
            <el-form-item :label="$t('SystemMaintenance.SendFTPFileNamePrefixsendFilePrefix')">
              <el-input v-model="maintainDialog.maintainForm.sendFilePrefix" />
            </el-form-item>
            <el-form-item :label="$t('SystemMaintenance.SendFTPAddressTypesendType')">
              <el-select v-model="maintainDialog.maintainForm.sendType" clearable>
                <el-option v-for="type in MODEL_TYPES" :key="type.code" :label="type.chineseName" :value="type.code" />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('SystemMaintenance.ServiceTypeServiceType')">
              <el-input v-model="maintainDialog.maintainForm.serviceType" />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SystemMaintenance.TemplateDescriptionTemplateDescribe') }}</span>
              <el-input v-model="maintainDialog.maintainForm.templateDescribe" />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SystemMaintenance.TemplateAccessPathTemplatePath') }}</span>
              <el-input v-model="maintainDialog.maintainForm.templatePath" />
            </el-form-item>
            <el-form-item :label="$t('SystemMaintenance.TemplateTypeTemplateType')">
              <el-input v-model="maintainDialog.maintainForm.templateType" />
            </el-form-item>
            <el-form-item :label="$t('SystemMaintenance.ShutNoticeShutOutIdentification')">
              <el-input v-model="maintainDialog.maintainForm.shutOutIdentification" />
            </el-form-item>
            <el-form-item :label="$t('SystemMaintenance.BootHelperPage')">
              <el-select v-model="maintainDialog.maintainForm.bootHelperPage" clearable>
                <el-option :label="$t('CargoMsg.Cargo_Temp')" :value="0" />
                <el-option label="PIL Common Version" :value="1" />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_BranchOffice')">
              <cargo-advance-select
                :select-type="TYPE_NAMES.basic_data_Office"
                multiple
                clearable
                filterable
                :default-multiple-value="maintainDialog.maintainForm.officeIdList instanceof Array ? maintainDialog.maintainForm.officeIdList : []"
                @parentCallBack="p=>{maintainDialog.maintainForm.officeIdList = p.value}"
              />
            </el-form-item>
            <!-- 船公司 -->
            <el-form-item :label="$t('CargoMsg.Cargo_ShippingCompany')">
              <cargo-company-select
                ref="shippingCompany"
                no="carrierId"
                :method-params="{active:true}"
                :default-value="maintainDialog.maintainForm.carrierId||''"
                @change="p=>{maintainDialog.maintainForm.carrierId=p.value;}"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_IfAutomaticBooking')">
              <el-select v-model="maintainDialog.maintainForm.ifAutoBooking">
                <el-option v-for="(item, index) in IF_AUTO_BOOKING" :key="index" :label="$getLangColumn(item)" :value="item.code" />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.BookingAgent')">
              <cargo-advance-select
                no="bookingAgent"
                :select-type="TYPE_NAMES.basic_data_Company"
                filterable
                :method-params="{bookingAgent:true,companyLob:'seaExport',active:true}"
                :default-value="maintainDialog.maintainForm.bookingAgent||''"
                @parentCallBack="p=>{maintainDialog.maintainForm.bookingAgent=p.value||0}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CarrierAgent')">
              <cargo-company-select
                no="carrierAgentId"
                :method-params="{seaCmpAgent:true,companyLob:'seaExport',active:true}"
                :default-value="maintainDialog.maintainForm.carrierAgentId||''"
                @change="p=>{maintainDialog.maintainForm.carrierAgentId=p.value||0}"
              />
            </el-form-item>
          </div>
        </el-form>
        <el-form label-width="120px" label-position="right">
          <div class="el-form-item-wrapper">
            <el-form-item>
              <span slot="label" style="position: relative; display: inline-block;">
                <span style="display: inline-block; width: 4px; height: 12px; background-color: #1f75d5; margin-right: 5px;" />
                {{ 'FTP/SFTP' + $t('CargoMsg.Cargo_Config') }}
              </span>
              <el-checkbox v-model="maintainDialog.maintainForm.openFtp" no="openFtp" @change="changeOpenFtp">{{ $t('SystemMaintenance.OpenConfig') }}</el-checkbox>
            </el-form-item>
            <el-form-item :label="$t('SystemMaintenance.SendType')">
              <el-radio-group v-model="maintainDialog.maintainForm.ftpType" :disabled="!isOpenFtp" no="ftpType" @change="changeFtpType">
                <el-radio :label="0">{{ 'FTP' }}</el-radio>
                <el-radio :label="1">{{ 'SFTP' }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ 'IP' }}</span>
              <el-input v-model="maintainDialog.maintainForm.ftpIp" :disabled="!isOpenFtp" style="width: 250px;" :filter-chars="false" />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ 'Port' }}</span>
              <el-input v-model="maintainDialog.maintainForm.ftpPort" :disabled="!isOpenFtp" :filter-chars="false" />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ 'Input.path' }}</span>
              <el-input v-model="maintainDialog.maintainForm.ftpInputPath" :disabled="!isOpenFtp" :filter-chars="false" />
            </el-form-item>
            <el-form-item :label="'Input.temp.path'">
              <el-input v-model="maintainDialog.maintainForm.ftpInputTempPath" :disabled="!isOpenFtp" :filter-chars="false" />
            </el-form-item>
            <el-form-item :label="'Output.path'">
              <el-input v-model="maintainDialog.maintainForm.ftpOutputPath" :disabled="!isOpenFtp" :filter-chars="false" />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ 'User' }}</span>
              <el-input v-model="maintainDialog.maintainForm.ftpUser" :disabled="!isOpenFtp" :filter-chars="false" />
            </el-form-item>
            <el-form-item v-if="isFtp">
              <span slot="label" class="blue">{{ 'Password' }}</span>
              <el-input v-model="maintainDialog.maintainForm.ftpPassword" type="password" :disabled="!isOpenFtp" :filter-chars="false" />
            </el-form-item>
            <el-form-item v-if="!isFtp" :label="'Password'">
              <el-input v-model="maintainDialog.maintainForm.ftpPassword" type="password" :disabled="!isOpenFtp" :filter-chars="false" />
            </el-form-item>
            <el-form-item v-if="!isFtp" :label="'PrivateKey'">
              <el-input v-model="maintainDialog.maintainForm.ftpPrivateKey" :disabled="!isOpenFtp" :filter-chars="false" />
            </el-form-item>
            <el-form-item v-if="!isFtp">
              <span slot="label" class="blue">{{ 'AuthType' }}</span>
              <el-select v-model="maintainDialog.maintainForm.ftpAuthType" :disabled="!isOpenFtp">
                <el-option :label="$t('SystemMaintenance.Key')" value="key" />
                <el-option :label="$t('SystemMaintenance.UserPwd')" value="userPwd" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <i class="el-icon-warning icon-tip" style="vertical-align: middle;margin-bottom: 2px;color: orange;font-size: 14px;" />
              <span style="margin-left: 3px;">{{ $t('SystemMaintenance.OpenConfigTip', [isFtp ? 'FTP' : 'SFTP']) }}</span>
              <br>
              <span style="margin-left: 16px;">{{ $t('SystemMaintenance.NotEmptyTips') }}</span>
            </el-form-item>
          </div>
        </el-form>
      </div>

      <div slot="footer">
        <el-button type="primary" @click="doSave">{{ $t('common.btn.save') }}</el-button>
        <el-button @click="cancelSaveOrEdit">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { deepClone } from '@/utils/index.js'
import { getLoading } from '@/utils/utilBaseElement'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { getGridSelected, getGridSelectedIds } from '@/utils/agGrid'
import { Assert } from '@/utils/validate'
import {
  getEDITemplate, addEDITemplate, updateEDITemplate, deleteEDITemplate
} from '@/api/sysManage/baseConfig/ediTemplate'
import * as ChargeItemTarget from '@/class/cargo/model/parameters/ChargeItemTarget'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import { IF_AUTO_BOOKING } from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'EdiTemplateSettings',
  components: {
    cargoAdvanceSelect, cargoCompanySelect
  },
  data() {
    return {
      loading: false,
      searchConditions: {
        likeName: ''
      },
      columnDefs: [
        {
          headerName: '', width: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        }, {
          headerName: this.$t('SystemMaintenance.EDIFileDefaultTypeDefaultFileType'),
          field: 'defaultFileType'
        }, {
          headerName: this.$t('SystemMaintenance.Emailemail'),
          field: 'email'
        }, {
          headerName: this.$t('SystemMaintenance.EDIFileEncodingTypeEncodingType'),
          field: 'encodingType'
        }, {
          headerName: this.$t('SystemMaintenance.EDIFileCombinationMethodFileCombineType'),
          field: 'fileCombineType'
        }, {
          headerName: this.$t('SystemMaintenance.PartnerCodeParnterId'),
          field: 'parnterId'
        }, {
          headerName: this.$t('SystemMaintenance.Remarksremarks'),
          field: 'remarks',
          width: 200
        }, {
          headerName: this.$t('SystemMaintenance.SendFTPFileNamePrefixsendFilePrefix'),
          field: 'sendFilePrefix',
          width: 200
        }, {
          headerName: this.$t('SystemMaintenance.SendFTPAddressTypesendType'),
          field: 'sendType',
          width: 200,
          cellRenderer: params => {
            const target = params.value ? ChargeItemTarget.getChargeItemTargetByCode2(params.value) : null
            return target ? target.chineseName : ''
          }
        }, {
          headerName: this.$t('SystemMaintenance.ServiceTypeServiceType'),
          field: 'serviceType'
        }, {
          headerName: this.$t('SystemMaintenance.TemplateDescriptionTemplateDescribe'),
          field: 'templateDescribe',
          width: 200
        }, {
          headerName: this.$t('SystemMaintenance.TemplateAccessPathTemplatePath'),
          field: 'templatePath',
          width: 200
        }, {
          headerName: this.$t('SystemMaintenance.TemplateTypeTemplateType'),
          field: 'templateType'
        }, {
          headerName: this.$t('SystemMaintenance.ShutNoticeShutOutIdentification'),
          field: 'shutOutIdentification'
        }, {
          headerName: this.$t('CargoMsg.Cargo_EDIFileType'),
          field: 'uploadFileSuffix'
        }
      ],
      originRowData: [],
      rowData: [],
      gridParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false
      },
      MODEL_TYPES: ChargeItemTarget.MODEL_TYPES,
      maintainDialog: {
        isShow: false,
        isEdit: false,
        title: this.$t('SystemMaintenance.EDITemplateMaintenance'),
        initMaintainForm: {
          parnterId: 0,
          templateDescribe: '',
          serviceType: 0,
          templateType: 0,
          templatePath: '',
          remarks: '',
          sendFilePrefix: '',
          sendType: '',
          fileCombineType: 0,
          defaultFileType: '',
          encodingType: '',
          email: '',
          shutOutIdentification: 0,
          bootHelperPage: 0,
          openFtp: 0, // 启动ftp配置
          ftpType: 0, // 发送模式
          ftpIp: '',
          ftpPort: '',
          ftpInputPath: '',
          ftpInputTempPath: '',
          ftpOutputPath: '',
          ftpUser: '',
          ftpPassword: '',
          ftpPrivateKey: '',
          ftpAuthType: 'key',
          bookingAgent: 0,
          carrierAgentId: 0,
          uploadFileSuffix: ''
        },
        maintainForm: {}
      },
      TYPE_NAMES, IF_AUTO_BOOKING
    }
  },
  computed: {
    isFtp() { // 发送模式是FTP
      return !this.maintainDialog.maintainForm.ftpType || this.maintainDialog.maintainForm.ftpType === 0
    },
    isOpenFtp() { // 是否启用配置
      return !!this.maintainDialog.maintainForm.openFtp
    }
  },
  mounted() {
    this.fetchEDITemplateList()
  },
  methods: {
    filterSearch() {
      const { likeName } = { ...this.searchConditions }
      this.rowData = this.originRowData.filter(item => item.remarks.toLowerCase().includes(likeName.toLowerCase()))
    },
    fetchEDITemplateList() {
      const self = this
      this.loading = getLoading()
      getEDITemplate({}).then(result => {
        self.rowData = result.data
        self.originRowData = deepClone(result.data)
        this.filterSearch()
      }).finally(
        self.loading.close()
      )
    },
    toAdd() {
      this.searchConditions.likeName = ''
      this.filterSearch()
      this.maintainDialog.maintainForm = { ...this.maintainDialog.initMaintainForm }
      if (!this.maintainDialog.maintainForm.ftpPort) {
        this.maintainDialog.maintainForm.ftpPort = ''
      }
      this.maintainDialog.isEdit = false
      this.maintainDialog.isShow = true
    },
    toEdit() {
      const self = this
      getGridSelectedIds(this.gridOptions).then(ids => {
        if (ids.length !== 1) {
          self.$message.error(self.$t('common.tips.hasOneOnly'))
        } else {
          self.maintainDialog.maintainForm = { ...getGridSelected(this.gridOptions)[0] }
          if (!self.maintainDialog.maintainForm.ftpPort) {
            self.maintainDialog.maintainForm.ftpPort = ''
          }
          this.maintainDialog.isEdit = true
          self.maintainDialog.isShow = true
        }
      })
    },
    doDelete() {
      const self = this
      getGridSelectedIds(this.gridOptions, 'uuid').then(async ids => {
        if (ids.length !== 1) {
          self.$message.error(self.$t('common.tips.hasOneOnly'))
        } else {
          await self.$confirm(self.$t('common.tips.confirmDelete'), self.$t('common.tips.confirm'), { type: 'warning' })
          self.loading = getLoading()
          deleteEDITemplate(ids[0]).then(() => {
            self.fetchEDITemplateList()
            self.$message.success(self.$t('common.tips.deleteSuccess'))
          }).finally(() => {
            self.loading.close()
          })
        }
      })
    },
    doSave() {
      if (this.maintainDialog.isEdit) {
        this.edit()
      } else {
        this.save()
      }
    },
    cancelSaveOrEdit() {
      this.maintainDialog.isShow = false
    },
    async save() {
      await this.checkForm()
      if (this.maintainDialog.maintainForm.hasOwnProperty('officeIdList') && !this.maintainDialog.maintainForm.officeIdList) {
        this.maintainDialog.maintainForm.officeIdList = []
      }
      const self = this
      this.loading = getLoading()
      addEDITemplate(this.maintainDialog.maintainForm).then(() => {
        self.fetchEDITemplateList()
        this.maintainDialog.isShow = false
        self.$message.success(self.$t('common.tips.saveSuccess'))
      }).finally(() => {
        self.loading.close()
      })
    },
    async edit() {
      await this.checkForm()
      if (this.maintainDialog.maintainForm.hasOwnProperty('officeIdList') && !this.maintainDialog.maintainForm.officeIdList) {
        this.maintainDialog.maintainForm.officeIdList = []
      }
      const self = this
      this.loading = getLoading()
      updateEDITemplate(this.maintainDialog.maintainForm).then(() => {
        this.maintainDialog.isShow = false
        self.fetchEDITemplateList()
        self.$message.success(self.$t('common.tips.editSuccess'))
      }).finally(() => {
        self.loading.close()
      })
    },
    async checkForm() {
      const { parnterId, templateDescribe, serviceType, templateType, templatePath, fileCombineType, shutOutIdentification } = { ...this.maintainDialog.maintainForm }
      await Assert.isNotBlank(fileCombineType, this.$t('SystemMaintenance.PleaseEDIFileCombinationMethod'), 'warning')
      await Assert.isNumber(fileCombineType, this.$t('SystemMaintenance.EDIMethodMustBeType'), 'warning')
      await Assert.isNotBlank(parnterId, this.$t('SystemMaintenance.PleaseEnterPartnerCode'), 'warning')
      await Assert.isNumber(parnterId, this.$t('SystemMaintenance.PartnerMustBeNumericType'), 'warning')
      await Assert.isNotBlank(serviceType, this.$t('SystemMaintenance.PleaseEnterServiceType'), 'warning')
      await Assert.isNumber(serviceType, this.$t('SystemMaintenance.ServiceMustBeNumericType'), 'warning')
      await Assert.isNotBlank(templateDescribe, this.$t('SystemMaintenance.PleaseEnterTemplateDescription'), 'warning')
      await Assert.isNotBlank(templatePath, this.$t('SystemMaintenance.PleaseEnterTemplateAccessPath'), 'warning')
      await Assert.isNotBlank(templateType, this.$t('SystemMaintenance.PleaseEnterTemplateType'), 'warning')
      await Assert.isNumber(templateType, this.$t('SystemMaintenance.TemplateMustBeNumericType'), 'warning')
      await Assert.isNumber(shutOutIdentification, this.$t('SystemMaintenance.ShutMustBeNumericType'), 'warning')
      const item = { ...this.maintainDialog.maintainForm }
      // 开启配置
      if (item.openFtp) {
        await Assert.isNotBlank(item.ftpIp, this.$t('CargoMsg.Cargo_PlsInput') + 'IP', 'warning')
        await Assert.isNotBlank(item.ftpPort, this.$t('CargoMsg.Cargo_PlsInput') + 'Port', 'warning')
        await Assert.isNumber(item.ftpPort, this.$t('SystemMaintenance.MustBeNumericType', ['Port']), 'warning')
        await Assert.isNotBlank(item.ftpInputPath, this.$t('CargoMsg.Cargo_PlsInput') + 'Input.path', 'warning')
        await Assert.isNotBlank(item.ftpUser, this.$t('CargoMsg.Cargo_PlsInput') + 'User', 'warning')
        if (this.isFtp) {
          await Assert.isNotBlank(item.ftpPassword, this.$t('CargoMsg.Cargo_PlsInput') + 'Password', 'warning')
        } else {
          await Assert.isNotBlank(item.ftpAuthType, this.$t('CargoMsg.Cargo_PlsInput') + 'AuthType', 'warning')
        }
      }
    },
    // 切换后清空之前的数据
    changeFtpType() {
      this.maintainDialog.maintainForm.ftpIp = ''
      this.maintainDialog.maintainForm.ftpPort = ''
      this.maintainDialog.maintainForm.ftpInputPath = ''
      this.maintainDialog.maintainForm.ftpInputTempPath = ''
      this.maintainDialog.maintainForm.ftpOutputPath = ''
      this.maintainDialog.maintainForm.ftpUser = ''
      this.maintainDialog.maintainForm.ftpPassword = ''
      this.maintainDialog.maintainForm.ftpPrivateKey = ''
      this.maintainDialog.maintainForm.ftpAuthType = !this.isFtp ? 'key' : ''
    },
    changeOpenFtp() {
      if (this.maintainDialog.maintainForm.openFtp) {
        this.maintainDialog.maintainForm.ftpType = 0
      }
    },
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword
    }
  }
}
</script>
